import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { obtenerEstadoTrafico } from '@utils/estadoTrafico';
import { useEffect } from 'react';

interface SelectProps {
    tableInfo: { id: number, descripcion: string, direccion?: string, libres?: string, nivel?: number, imagen?: string, enlace?: string, carga?: number }[];
    setTableInfo: (tableInfo: { id: number, descripcion: string, direccion?: string, libres?: string, nivel?: number, imagen?: string, enlace?: string, carga?: number }[]) => void;
}

export default function BasicSelect({ tableInfo, setTableInfo }: SelectProps) {
    const [state, setState] = React.useState('');
    const rootStyles = getComputedStyle(document.documentElement);
    const principalColor = rootStyles.getPropertyValue('--primary-color');
    const [nivelTrafico, setNivelTrafico] = React.useState(3)
    useEffect(() => {
        const loadConfig = async () => {
            try {
                const response = await fetch('/config.json');
                const config = await response.json();
                setNivelTrafico(config.NIVEL_TRAFICO)
            } catch (error) {
                console.error('Error loading config:', error);
            }
        };

        loadConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChange = (event: SelectChangeEvent) => {
        if (event.target.value === "Todos") {
            setTableInfo(tableInfo);
            setState(event.target.value);
            return;
        }
        const values = tableInfo.filter(row => {
            return obtenerEstadoTrafico(row.carga, nivelTrafico).nombre === event.target.value;
        });
        setState(event.target.value as string);
        setTableInfo(values);
    };

    return (
        <Box sx={{ minWidth: 150 }}>
            <FormControl fullWidth>
                <InputLabel id="estado-select-label" sx={{
                    color: principalColor,
                    '&.Mui-focused': {
                        color: principalColor,
                    },
                }}>Estado</InputLabel>
                <Select
                    labelId="estado-select-label"
                    id="estado-select"
                    value={state}
                    label="Estado"
                    onChange={handleChange}
                    sx={{
                        backgroundColor: 'transparent',
                        color: principalColor,
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: principalColor,
                            color: principalColor
                        },
                        '& .MuiSelect-select': {
                            color: principalColor,
                            '&:focus': {
                                backgroundColor: 'transparent',
                                color: principalColor
                            },
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: principalColor,
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: principalColor,
                        },
                        '& .MuiSvgIcon-root': {
                            color: principalColor,
                        }
                    }}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        },
                    }}
                >
                    {nivelTrafico === 3 && [
                        <MenuItem key="Todos" value="Todos">Todos</MenuItem>,
                        <MenuItem key="Retenciones" value="Retenciones">Retenciones</MenuItem>,
                        <MenuItem key="Tráfico intenso" value="Tráfico intenso">Tráfico Intenso</MenuItem>,
                        <MenuItem key="Tráfico Fluido" value="Tráfico fluido">Tráfico Fluido</MenuItem>
                    ]}
                    {nivelTrafico === 5 && [
                        <MenuItem key="Todos" value="Todos">Todos</MenuItem>,
                        <MenuItem key="Congestión" value="Congestión">Congestión</MenuItem>,
                        <MenuItem key="Muy Denso" value="Muy Denso">Muy Denso</MenuItem>,
                        <MenuItem key="Denso" value="Denso">Denso</MenuItem>,
                        <MenuItem key="Fluido" value="Fluido">Fluido</MenuItem>,
                        <MenuItem key="Muy Fluido" value="Muy Fluido">Muy Fluido</MenuItem>
                    ]}
                </Select>
            </FormControl>
        </Box>
    );
}
